module.exports = __webpack_public_path__ + "img/center19.c8c2c77e.png";